var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../ModelTraits";
import objectTrait from "../Decorators/objectTrait";
import LatLonHeightTraits from "./LatLonHeightTraits";
import HeadingPitchRollTraits from "./HeadingPitchRollTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
let TransformationTraits = (_dec = objectTrait({
  type: LatLonHeightTraits,
  name: "Origin",
  description: "The origin of the model, expressed as a longitude and latitude in degrees and a height in meters. If this property is specified, the model's axes will have X pointing East, Y pointing North, and Z pointing Up. If not specified, the model is located in the Earth-Centered Earth-Fixed frame."
}), _dec2 = objectTrait({
  type: HeadingPitchRollTraits,
  name: "Rotation",
  description: "The rotation of the model expressed as heading, pitch and roll in the local frame of reference. Defaults to zero rotation."
}), _dec3 = primitiveTrait({
  type: "number",
  name: "Scale",
  description: "The scale factor to apply to the model"
}), _class = class TransformationTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "origin", _descriptor, this);
    _initializerDefineProperty(this, "rotation", _descriptor2, this);
    _initializerDefineProperty(this, "scale", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "origin", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "rotation", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "scale", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TransformationTraits as default };